import classNames from "classnames";
import { FC } from "react";
import { Glyph } from "../../../types";
import Icon from "../../ui/Icon";
import Inline from "../../ui/Inline";
import styles, { shownIcon } from "./InfoCell.module.css";

type InfoCellProps = {
  title: string;
  text?: string;
  sideIcon?: Glyph;
  onClick?: () => void;
};

const InfoCell: FC<InfoCellProps> = ({ title, text, sideIcon, onClick }) => {
  return (
    <div className={classNames(styles.infoCell, [!!onClick ? styles.pointer : undefined])} onClick={onClick}>
      <Inline alignItems="center" flexWrap="nowrap">
        <strong>{title}</strong>
        <span className={!!onClick ? styles.hoverIcon : shownIcon}>
          {!!sideIcon && <Icon className={styles.generalDataIcon} glyph={sideIcon} />}
        </span>
      </Inline>
      {!!text && <div>{text}</div>}
    </div>
  );
};

export default InfoCell;
